<style>
 .textDecoration{
  text-decoration: underline;
  color: #44bd32 !important;
  padding: 0px 5px;
 }
</style>
<template>
  <div>
    <Row class="p-b-5">
      <i-col span="12">
        <span class="workplatform-title">{{ contractInfo.name }}</span>
        <span class="m-l-10 m-r-10 workplatform-title">{{ contractInfo.code }}</span>
        <Tag color="blue">{{ contractInfo.rentTypeName }}</Tag>
        <!-- <Tag class="m-l-5" color="green" v-if="!showDisCount">
          {{contract.contractCategoryName}}
        </Tag>
        <Tag
          class="m-l-5"
          color="blue"
          v-else-if="contract.contractCategory === 2"
          >{{contract.contractCategoryName}}</Tag
        >
        <Tag class="m-l-5" color="blue" v-else-if="contract.type === 3"
          >代理商合同</Tag
        > -->
      </i-col>
      <i-col span="12" class="text-right" v-if="contractInfo.lastApprovedTime">
        <label class="title">最后审核时间 </label>
        <label>{{ contractInfo.lastApprovedTime }}</label>
      </i-col>
    </Row>

    <p class="text-14 p-b-10">基础信息</p>
    <template v-if="contractInfo.firstParty">
      <Row>
        <i-col span="24">
          <span class="title"> 甲方 </span>
          <span>{{ contractInfo.firstParty.partyName || "无" }}</span>
        </i-col>
        <i-col span="8"
          ><span class="title">法定代表人 </span
          >{{ contractInfo.firstParty.partyLegalName }}</i-col
        >
        <i-col span="8"
          ><span class="title"
            >{{
              contractInfo.firstParty.partyType === 10
                ? "社会统一信用代码"
                : "身份证号"
            }} </span
          >{{ contractInfo.firstParty.partyOrgCode }}</i-col
        >
        <i-col span="8"
          ><span class="title">地址 </span
          >{{ contractInfo.firstParty.partyAddress }}</i-col
        >
      </Row>
      <Row class="p-b-5">
        <i-col span="8"
          ><span class="title">创建人</span
          >{{ contractInfo.createUserName }}</i-col
        >
        <i-col span="8"
          ><span class="title">创建时间 </span
          >{{ contractInfo.createTime }}</i-col
        >
      </Row>
    </template>
    <Row class="p-b-10 p-t-5" v-if="contractInfo.secondParty">
      <i-col span="24">
        <span class="title">乙方 </span>
        <span class="m-r-10">{{ contractInfo.secondParty.partyName }}</span>
        <Tag v-if="contractInfo.secondParty.partyType===10" color="green">企业</Tag>
        <Tag v-else color="cyan">个人</Tag>
      </i-col>

      <template v-if="contractInfo.secondParty.partyType === 10">
        <i-col span="8"
          ><span class="title">统一社会信用代码 </span
          >{{ contractInfo.secondParty.partyOrgCode }}</i-col
        >
        <!-- <i-col span="8"
          ><span class="title">法定代表人 </span
          >{{ contractInfo.secondParty.partyLegalName }}</i-col
        >
        <i-col span="8"
          ><span class="title">公司电话 </span
          >{{ contractInfo.secondParty.tel }}</i-col
        > -->
        <i-col span="8"
          ><span class="title">联系人 </span
          >{{ contractInfo.secondParty.delegateName }}</i-col
        >
        <i-col span="8"
          ><span class="title">联系人电话 </span
          >{{ contractInfo.secondParty.delegatePhone }}</i-col
        >
      </template>
      <template v-else>
        <!-- <i-col span="8"
          ><span class="title">承租人 </span
          >{{ contractInfo.secondParty.partyName }}</i-col
        > -->
        <i-col span="8"
          ><span class="title">承租人电话 </span
          >{{ contractInfo.secondParty.partyPhone }}</i-col
        >
        <i-col span="8"
          ><span class="title">身份证号 </span
          >{{ contractInfo.secondParty.partyOrgCode }}</i-col
        >
      </template>

      <i-col span="8"
        ><span class="title">地址 </span
        >{{ contractInfo.secondParty.partyAddress }}</i-col
      >
    </Row>

    <p class="text-14">合同日期</p>
    <Row class="p-b-5 p-t-10" style="line-height: 24px">
      <i-col span="6"
        ><span class="title">合同开始日期 </span
        >{{ contractInfo.startDate }}</i-col
      >
      <i-col span="6"
        ><span class="title">合同结束日期 </span
        >{{ contractInfo.endDate }}</i-col
      >
      <i-col span="6"
        ><span class="title">合同签订日期 </span
        >{{ contractInfo.signDate }}</i-col
      >
      <!-- <i-col span="6"
        ><span class="title">房屋交付日期 </span
        >{{ contractInfo.deliveryDate }}</i-col
      >
      <i-col span="6"
        ><span class="title">最晚运营日期 </span
        >{{ contractInfo.businessDate }}</i-col
      > -->
    </Row>
    <Row class="p-b-10" style="line-height: 24px">
      <i-col span="24">
        <span class="title">合同附加条款 </span>
        {{ contractInfo.description }}
      </i-col>
    </Row>

    <p class="text-14">资产信息</p>
    <Row class="p-b-5 p-t-10" style="line-height: 24px">
      <i-col span="24">
        <Table
          size="small"
          :columns="columnData"
          :data="tableData"
          stripe
        ></Table
      ></i-col>
    </Row>

    <p class="text-14 m-t-10">不计费区间</p>
    <Row :gutter="8" class="p-b-5 p-t-10">
      <i-col span="24">
        <div v-if="!freePeriodArray.length">本合同未约定不计费区间</div>
        <div v-else>本合同约定不计费区间如下：</div>
        <p v-for="(item, index) in freePeriodArray" :key="index">
          {{ index + 1 }}.
          <label v-if="item.type === 1" style="line-height: 35px">
            <span class="textDecoration">{{ item.coNames }}</span
            >，在
            <span class="textDecoration">
              {{ item.startDate }} 至 {{ item.endDate }}</span
            >
            区间， 不计算
            <span class="textDecoration">{{ getFeeTypeName(item.feeType)}}</span>
          </label>
          <label v-if="item.type === 2" style="line-height: 35px">
            <span class="textDecoration">{{ item.coNames }}</span
            >，自资产交付日起
            <span class="textDecoration"> {{ item.duration }}</span
            >个月，不计算
            <span class="textDecoration">{{ getFeeTypeName(item.feeType)}}</span>
          </label>
        </p>
      </i-col>
    </Row>

    <p class="text-14 m-t-10">账单费用合计</p>
    <Row :gutter="8" class="p-b-5 p-t-10">
      <i-col span="24">
        <p>
        全部账单总额：<span class="money"> {{ formatMoney(statistics.total) }}</span>
        </p>
        <p v-for="(item,index) in statistics.groupArray" :key="index" class="m-t-5">
          {{ item.assetName }}<Divider type="vertical" />
          <span v-for="(ele,index2) in item.data" :key="index2" class="m-r-10">
            {{ ele.feeTypeName }}：<span class="money"> {{ formatMoney(ele.amount) }}</span>
          </span>
        </p>
      </i-col>
    </Row>

    <p class="text-14 m-t-10">其他费用</p>
    <Row class="p-b-5 p-t-5">
      <i-col span="24">
        <div v-if="!otherFeeData.length">本合同未约定其他费用</div>
        <div v-else>本合同约定其他费用如下：</div>
        <p v-for="(item, index) in otherFeeData" :key="index">
          {{ index + 1 }}.
          <label>
            于
            <span class="textDecoration">{{ item.payDate }}</span>
            之日前，⼄⽅需向甲⽅⽀付
            <span class="textDecoration">{{ item.feeName }}</span>
            ，金额
            <span class="textDecoration"> {{ formatMoney(item.amount) }}</span>
            元（⼈⺠币
            <span class="textDecoration">{{ formatUpperMoney(item.amount) }}</span>）。
            <span>{{ item.remark}}</span>
          </label>
        </p>
      </i-col>
    </Row>

    <p class="text-14 m-t-10 m-b-10">合同附件</p>
    <Row :gutter="8" class="mb-2">
      <i-col span="24">
        <RadioGroup
          v-model="fileType"
          type="button"
          button-style="solid"
        >
          <Radio
            v-for="item in contractfiletypes"
            :key="item.id"
            :label="item.id"
            >{{ item.name }}</Radio
          >
        </RadioGroup>
      </i-col>
    </Row>
    <Table :columns="fileColumns" stripe size="small" :data="fileList"></Table>

  </div>
</template>

<script>
// import { getPositions } from '@/api/product/resource'
// import { addDevice, updateDevice } from '@/api/product/deviceedit'
// import { ParseDate } from '@/utils/dateFormat'
import em from '@/utils/enum'

import { downloadFileRequest } from '@/utils/download'
import { signurlByAttach } from '@/api/resource/endpoint'
import { parseUpperMoney } from '@/utils/index'
import { toMoney } from '@/utils/wnumb_own'
/** new api */
import { listDictLabel } from '@/api/invest/dict'
import { createDebtDetail, countAmountGbAsset } from '@/api/invest/debt'
import {
  getContractInfo,
  listObjectAndFee,
  listFreePeriod,
  listOtherFee
} from '@/api/invest/contract'
import { getFileList } from '@/api/invest/file'

export default {
  components: {},
  props: {
    createTempBill: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      contractInfo: {},
      deviceListModal: false,

      dateUnitArray: em.dateUnitArray,

      contractResourceArray: [],
      tableData: [],
      columnData: [
        { title: '编码', dataIndex: 'objectCode', key: 'objectCode' },
        // { title: '名称', dataIndex: 'objectName', key: 'objectName' },
        {
          title: '类型',
          dataIndex: 'resourceTypeName',
          key: 'resourceTypeName'
        },
        {
          title: '计费周期',
          width: '200px',
          key: 'feeStartDate',
          align: 'center',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach((item) => {
              resultStr.push(h('p', {}, item.startDate + '至' + item.endDate))
            })

            return h('div', resultStr)
          }
        },
        {
          title: '计费类型',
          key: 'feeTypeName',
          width: '150',
          align: 'center',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach(item => {
              resultStr.push(h(
                'p', {},
                item.feeTypeName
              ))
            })

            return h('div', resultStr)
          }
        },
        {
          title: '计费数量',
          key: 'number',
          align: 'center',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach((item) => {
              resultStr.push(h('p', {}, item.number))
            })

            return h('div', resultStr)
          }
        },
        {
          title: '计费单价',
          key: 'feeSignPrice',
          align: 'center',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach((item) => {
              resultStr.push(h('p', {}, item.signPrice + '元/' + this.formatDateUnit(item.dateUnit)))
            })

            return h('div', resultStr)
          }
        },
        {
          title: '小计',
          width: '160px',
          key: 'feeMonthPrice',
          align: 'center',
          render: (h, params) => {
            const resultStr = []
            params.row.feeList.forEach((item) => {
              resultStr.push(h('p', {}, item.monthPrice + '元/' + this.formatDateUnit(item.dateUnit)))
            })

            return h('div', resultStr)
          }
        }
      ],
      feeTypeArray: [],
      freePeriodArray: [],
      otherFeeData: [],

      statistics: {
        total: 0,
        groupArray: []
      },

      contractfiletypes: [],
      fileType: 0,
      fileList: [],
      fileColumns: [
        { title: '文件名称', dataIndex: 'fileName', key: 'fileName' },
        { title: '文件分类', dataIndex: 'fileTypeName', key: 'fileTypeName' },
        { title: '文件类型', dataIndex: 'mimeType', key: 'mimeType' },
        // { title: '文件大小', dataIndex: 'length', key: 'length' },
        { title: '上传时间', dataIndex: 'createTime', key: 'createTime' },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          render: (h, params) => {
            const detailButton = h(
              'a',
              {
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.handleDownload(params.row)
                  }
                }
              },
              '下载'
            )
            const returnBtns = []

            returnBtns.push(detailButton)
            return h('div', returnBtns)
          }
        }
      ]
    }
  },
  mounted () {
    if (this.id) {
      this.initBaseData(this.id)
    }
  },
  created () {
    listDictLabel({ dictType: 'fee_type' }).then(res => {
      this.feeTypeArray = res.map(x => {
        return {
          id: parseInt(x.id),
          name: x.name
        }
      })
    })
  },
  methods: {
    initBaseData (contractId) {
      this.initContractDetail(contractId)
      this.initlistResourceAndFee(contractId)
      if (this.createTempBill) { // 创建临时账单，用于计算费用汇总
        createDebtDetail({ contractId: contractId }).then(res => {
          if (res.success) {
            this.getFeeStatistics(contractId)
          }
        })
      } else {
        // 直接获取账单， 并计算费用汇总
        this.getFeeStatistics(contractId)
      }
    },
    getFeeStatistics (contractId) {
      // 载入账单信息
      countAmountGbAsset({ contractId: contractId }).then(res => {
        const groupAsset = []
        this.statistics = {
          total: 0,
          groupArray: []
        }

        res.forEach(element => {
          if (!groupAsset.includes(element.assetName)) {
            groupAsset.push(element.assetName)
          }
          // 统计账单总额
          this.statistics.total += element.amount
        })

        // 开始计算线路数据
        let assetData = []
        let curAssetDataByFeeType = null
        let assetDataByFeeType = []

        groupAsset.forEach(element => {
          assetDataByFeeType = []
          assetData = res.filter(x => x.assetName === element)

          assetData.forEach(assetItem => {
            curAssetDataByFeeType = assetDataByFeeType.find(x => x.feeTypeName === assetItem.feeTypeName)
            if (curAssetDataByFeeType) {
              curAssetDataByFeeType.amount += assetItem.amount
            } else {
              assetDataByFeeType.push({
                feeTypeName: assetItem.feeTypeName,
                amount: assetItem.amount
              })
            }
          })

          this.statistics.groupArray.push({
            assetName: element,
            data: assetDataByFeeType
          })
        })
      })
    },
    handleDownload (file) {
      signurlByAttach({ attachId: file.filePath }).then((res) => {
        downloadFileRequest(res.data, {}, file.fileName)
      })
    },
    formatMoney (number) {
      return toMoney(number)
    },
    formatUpperMoney (money) {
      return parseUpperMoney(money)
    },
    formatDateUnit (type) {
      const unit = this.dateUnitArray.find(x => x.value === type)
      return unit ? unit.name : ''
    },
    initContractDetail (contractId) {
      const that = this
      getContractInfo({ contractId: contractId, hideFlag: 1 }).then((res) => {
        that.contractInfo = res
        that.initFreePeriodList()

        that.initFileTypes()
      })
    },

    getFeeTypeName (type) {
      const fee = this.feeTypeArray.find(x => x.id === type)
      return fee ? fee.name : '未知'
    },
    initFreePeriodList () {
      listFreePeriod({ contractId: this.contractInfo.id }).then((res) => {
        this.freePeriodArray = res
      })
      listOtherFee({ contractId: this.contractInfo.id }).then((res) => {
        this.otherFeeData = res
      })
    },
    initlistResourceAndFee (contractId) {
      const that = this
      listObjectAndFee({ contractId: contractId }).then((res) => {
        that.tableData = res
      })
    },
    initFileTypes () {
      // 文件类型
      listDictLabel({ dictType: 'contract_file_type' }).then((res) => {
        this.contractfiletypes = [
          {
            id: 0,
            name: '全部文件'
          }
        ]
        this.contractfiletypes = this.contractfiletypes.concat(
          res.map((item) => {
            return { id: item.id, name: item.name }
          })
        )
        // this.fileType = this.contractfiletypes[0].id
        this.reloadFileList()
      })
    },
    reloadFileList () {
      const query = {
        category: 2,
        keyId: this.contractInfo.id
      }
      if (this.fileType > 0) {
        query.fileType = this.fileType
      }
      getFileList(query).then((res) => {
        this.fileList = res
      })
    }
  },
  watch: {
    fileType () {
      this.reloadFileList()
    },
    id () {
      this.initContractDetail()
    },
    beginUpdate () {
      this.initContractDetail()
    }
  },
  computed: {
    id () {
      return this.$store.state.investmentContract ? this.$store.state.investmentContract.id : null
    },
    beginUpdate () {
      return this.$store.state.investmentContract ? this.$store.state.investmentContract.beginUpdate : null
    }
  }
}
</script>
